// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"bd140389","453":"f50ef6f4","747":"e2304921"}[chunkId] + ".chunk.js";
};